import React, { useState, useEffect } from 'react';
import { ErrorMessage, Field, FieldProps } from 'formik';
import Select, { OptionsType } from 'react-select';

import errorReporter from '@app/errorReporter';
import API from 'api';
import { StyledTableDataContents, StyledTableDataLabel } from './styled';

const reactSelectCustomStyles = {
  menu: (provided: any) => ({
    ...provided,
  }),
  control: (base: any) => ({
    ...base,
    borderColor: `#e4e5e7 !important`,
  }),
  singleValue: (provided: any) => ({ ...provided }),
};

type LockboxAgentSelectProps = {
  selectedAgentId: string;
  handleChange(value?: any): void;
  inputName: string;
  disabled: boolean;
  setFieldTouched: any;
};

const LockboxAgentSelect: React.FC<LockboxAgentSelectProps> = ({
  selectedAgentId,
  handleChange,
  inputName,
  disabled,
  setFieldTouched,
}) => {
  const [agentOptions, setAgentOptions] = useState<
    OptionsType<{ label: string; value: string }>
  >([]);

  useEffect(() => {
    (async () => {
      try {
        const agents = await API.GET.getAssignableUsers();

        setAgentOptions(
          agents.map(agent => ({
              label: `${agent.firstName} ${agent.lastName}`,
              value: agent._id,
            })),
        );
      } catch (err) {
        errorReporter.error(err);
      }
    })();
  }, []);

  return (
    <tr>
      <StyledTableDataLabel>
        <label>Assign to agent: </label>
      </StyledTableDataLabel>
      <StyledTableDataContents>
        <Field name={inputName}>
          {({ field: { name, onBlur } }: FieldProps) => (
            <Select
              value={
                agentOptions.find(agent => agent.value === selectedAgentId) ||
                null
              }
              styles={reactSelectCustomStyles}
              placeholder="Assigned Agent"
              onChange={agent => {
                if (agent && 'value' in agent) {
                  handleChange(agent.value);
                } else {
                  handleChange('');
                }
              }}
              onBlur={value => {
                setFieldTouched(name);
                if (onBlur) onBlur(value);
              }}
              isSearchable
              isClearable
              isDisabled={disabled}
              options={agentOptions}
              noOptionsMessage={() => 'No agents Found'}
            />
          )}
        </Field>
        <ErrorMessage name={inputName} component="label" className="error" />
      </StyledTableDataContents>
    </tr>
  );
};

export default LockboxAgentSelect;
